import { IDReg } from './Regs';
import moment from 'moment';
/**
 * 返回身份证信息
 * @param {string} ID 身份证号码
 */
export const getIdCardInfo = ID => {
    const Provinces = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外',
    };
    let IDInfo = null;
    if (IDReg.test(ID)) {
        IDInfo = {
            success: true,
            birthday: moment(ID.substring(6, 14)).format('YYYY-MM-DD'),
            age:
                Number(new Date().getFullYear() - ID.substring(6, 10)) -
                (moment(new Date().getFullYear() + ID.substring(10, 14)).valueOf() -
                    moment().valueOf() >
                0
                    ? 1
                    : 0),
            gender: +ID.substring(16, 17) % 2 === 1 ? '男' : '女', // 1 => 男  0 => 女
            province: Provinces[ID.substring(0, 2)],
            // isFZ: ID.substring(0, 4) === '3501' && ID.substring(0, 6) !== '350128', // 是否福州非平潭
        };
    } else {
        IDInfo = {
            success: false,
        };
    }
    return IDInfo;
};

/**
 * 返回枚举值
 * @param {array} filter 枚举集合
 * @param {string} val val
 */
export const getFilterText = (filter, val, notFoundVal = '--') => {
    return (
        (
            (filter || []).find(item => {
                return item.value === val;
            }) || {}
        ).text || notFoundVal
    );
};

export const debounce = (fn, wait, time) => {
    let previous = null; // 记录上一次运行的时间
    let timer = null;
    return function () {
        const now = +new Date();
        if (!previous) previous = now;
        // 当上一次执行的时间与当前的时间差大于设置的执行间隔时长的话，就主动执行一次
        if (now - previous > time) {
            clearTimeout(timer);
            fn();
            previous = now; // 执行函数后，马上记录当前时间
        } else {
            // 否则重新开始新一轮的计时
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn();
            }, wait);
        }
    };
};

export const throttle = (fn, time) => {
    const _self = fn;
    let timer = '';
    let firstTime = true; // 记录是否是第一次执行的flag

    return function () {
        const args = arguments; // 解决闭包传参问题
        const _me = this; // 解决上下文丢失问题

        if (firstTime) {
            // 若是第一次，则直接执行
            _self.apply(_me, args);
            firstTime = false;
            return;
        }
        if (timer) {
            // 定时器存在，说明有事件监听器在执行，直接返回
            return false;
        }

        timer = setTimeout(function () {
            clearTimeout(timer);
            timer = null;
            _self.apply(_me, args);
        }, time || 500);
    };
};

// 流文件下载
export const downFile = (content, filename) => {
    // 字符内容转变成blob地址
    const blob = new Blob([content]);
    if (window.navigator.msSaveOrOpenBlob) {
        // For IE:
        navigator.msSaveBlob(blob, filename);
    } else {
        // For other browsers:
        const ele = document.createElement('a'); // 创建下载链接
        ele.download = filename; // 设置下载的名称
        ele.style.display = 'none'; // 隐藏的可下载链接
        ele.href = URL.createObjectURL(blob);
        // 绑定点击时间
        document.body.appendChild(ele);
        ele.click();
        // 然后移除
        document.body.removeChild(ele);
    }
};
